import { CronExpressionModalComponent } from './../cron-expression-modal/cron-expression-modal.component';
import { EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CustomAdapter } from './../../../execution-history/testsuite/testsuite.component';
import { NgbDateAdapter, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ScheduleService } from './../schedule.service';
import { FormBuilder } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { Component, Injectable, Input, OnInit, Output } from '@angular/core';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';
  parse(value: string): NgbDateStruct {
    let result: NgbDateStruct;
    if (value) {
      const date = value.split(this.DELIMITER);
      result = {
        year: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        day: parseInt(date[2], 10)
      };
    }
    return result;
  }

  format(date: NgbDateStruct): string {
    let result = '';
    if (date) {
      if (date.day < 10) { result = result + '0'; }
      result = result + date.day + this.DELIMITER;
      if (date.month < 10) { result = result + '0'; }
      result = result + date.month;
      result = result + this.DELIMITER + date.year;
    }
    return result;
  }
}

@Injectable()
export class CustomTimeParser extends NgbTimeAdapter<string> {

  fromModel(value: string): NgbTimeStruct {
    if (!value) {
      return null;
    }
    const split = value.split(':');
    return {
      hour: parseInt(split[0], 10),
      minute: parseInt(split[1], 10),
      second: parseInt(split[2], 10)
    };
  }

  toModel(time: NgbTimeStruct) {
    if (!time) {
      return null;
    }
    return `${this.pad(time.hour)}:${this.pad(time.minute)}:${this.pad(time.second)}`;
  }

  private pad(i: number): string {
    return i < 10 ? `0${i}` : `${i}`;
  }
}

@Component({
  selector: "app-schedule-form",
  templateUrl: "./schedule-form.component.html",
  styleUrls: ["./schedule-form.component.less"],
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    { provide: NgbTimeAdapter, useClass: CustomTimeParser },
    DatePipe,
  ],
})
export class ScheduleFormComponent implements OnInit {
  @Input() newScheduleForm: FormGroup;
  @Input() selectedScheduledExecution: any;
  scheduledExecutions: any;

  @Input() fromParent: any;
  @Output() scheduledExecutionTrigger: EventEmitter<any> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private scheduleService: ScheduleService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    public modal: NgbActiveModal,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.setForm();
    this.setMindate();
    if (this.selectedScheduledExecution !== undefined) {
      this.setEditSchedule();
    }
    if((this.fromParent.moduleDetails.project.projectConfig.preferences && this.fromParent.moduleDetails.project.projectConfig.preferences?.environment !== null && this.fromParent.moduleDetails.project.projectConfig.preferences.environment !== undefined)  && this.fromParent.moduleType == 'ENDPOINT') {

      let selectedEnvironment = this.fromParent.child.activeEnv.filter((item) => {
        if(item.id == this.fromParent.moduleDetails.project.projectConfig.preferences.environment) return item
      });
      if(selectedEnvironment.length > 0) {
        this.newScheduleForm.get("environment").setValue(selectedEnvironment[0]);
      }
    }
    if((this.fromParent.moduleDetails.project.projectConfig.preferences && this.fromParent.moduleDetails.project.projectConfig.preferences?.environmentMapper !== null && this.fromParent.moduleDetails.project.projectConfig.preferences.environmentMapper !== undefined) && this.fromParent.moduleType !== 'ENDPOINT') {
      let selectedEnvironmentMapper = this.fromParent.child.activeEnv.filter((item) => {
        if(item.id == this.fromParent.moduleDetails.project.projectConfig.preferences.environmentMapper) return item
      });
      if(selectedEnvironmentMapper.length > 0) {
        this.newScheduleForm.get("environmentMap").setValue(selectedEnvironmentMapper[0]);
      }
    }
    /* Get OS dropdown */
    if(this.fromParent.moduleDetails.project.projectConfig.preferences && this.fromParent.moduleDetails.project.projectConfig.preferences.osType !== null && this.fromParent.moduleDetails.project.projectConfig.preferences.osType !== undefined) {
      this.newScheduleForm.get("os").setValue(this.fromParent.moduleDetails.project.projectConfig.preferences.osType);
    }

    /* Get OS dropdown */
    if(this.fromParent.moduleDetails.project.projectConfig.preferences && this.fromParent.moduleDetails.project.projectConfig.preferences.browserType !== null && this.fromParent.moduleDetails.project.projectConfig.preferences.browserType !== undefined) {
      this.newScheduleForm.get("browserType").setValue(this.fromParent.moduleDetails.project.projectConfig.preferences.browserType);
    }
  }

  setForm() {
    this.newScheduleForm = this.formBuilder.group({
      id: [null],
      name: [null, Validators.required],
      startDate: [""],
      beginDate: [null, Validators.required],
      time: [null, Validators.required],
      cron: [null, Validators.required],
      active: [null],
      disableOnFailure: [null],
      environmentMap: [null, Validators.required],
      environment: [null],
      os: ["WINDOWS"],
      browserType: ["CHROME"],
      executionEntityId: [null],
      executionEntityType: [null],
    });

    this.newScheduleForm.get("beginDate").setValue(this.getCurrentUTCDate());
    this.newScheduleForm.get("time").setValue(this.getCurrentUTCTime());

    if (this.fromParent.moduleType === "ENDPOINT") {
      this.newScheduleForm.get("environmentMap").disable();
      if (this.fromParent.moduleDetails.environmentSpecific) {
        this.newScheduleForm.controls.environment.setValidators([
          Validators.required,
        ]);
        this.newScheduleForm.controls.environment.updateValueAndValidity();
      } else {
        this.newScheduleForm.controls.environment.clearValidators();
        this.newScheduleForm.controls.environment.updateValueAndValidity();
      }
    } else {
      this.newScheduleForm.get("environment").disable();
    }
  }

  get scheduleDate() {
    return this.newScheduleForm.controls.beginDate;
  }

  onSubmit() {
    let formVal = this.newScheduleForm.value;

    formVal.executionEntityId = this.fromParent.moduleDetails["id"];

    // Setting the execution value
    formVal.executionEntityType = this.getExecutionEntityType(
      this.fromParent.moduleType
    );

    if (this.fromParent.moduleType === "ENDPOINT") {
      delete formVal.environmentMap;
    } else {
      delete formVal.environment;
    }

    if (!this.fromParent.moduleDetails["showBrowserOptions"]) {
      delete formVal.os;
      delete formVal.browser;
    }

    formVal.startDate = formVal.beginDate + " " + formVal.time;
    delete formVal.time;
    delete formVal.beginDate;

    if (this.fromParent.isEdit) {
      this.scheduleService.updateSchedule(formVal).subscribe((data) => {
        if (data.code === 200) {
          this.setForm();
          this.setMindate();
          this.toastr.success(data.message);
          this.scheduledExecutionTrigger.emit();
        } else if (data.errorCode === 500) {
          this.toastr.error(data.errorMessage);
        }
      });
    } else {
      this.scheduleService.createSchedule(formVal).subscribe((data) => {
        if (data.code === 200) {
          this.setForm();
          this.toastr.success(data.message);
          this.scheduledExecutionTrigger.emit();
        } else if (data.errorCode === 500) {
          this.toastr.error(data.errorMessage);
        }
      });
    }

    this.cancel();
  }

  cancel() {
    this.modal.close();
    this.setForm();
    this.setMindate();
  }

  getExecutionEntityType(moduleType: string) {
    let entityType: string;

    switch (moduleType) {
      case "ENDPOINT":
        entityType = "END_POINT";
        break;

      case "TESTCASE":
        entityType = "TEST_CASE";
        break;

      case "TESTSUITE":
        entityType = "TEST_SUITE";
        break;

      case "MASTERSUITE":
        entityType = "MASTER_SUITE";
        break;

      default:
        entityType = null;
        break;
    }

    return entityType;
  }

  setEditSchedule() {
    this.setForm();
    this.newScheduleForm.patchValue(this.selectedScheduledExecution);
    const date = this.newScheduleForm.value.startDate;
    const splitDate = date.split(" ")[0];
    const splitTime = date.split(" ")[1];
    this.newScheduleForm.get("beginDate").setValue(splitDate);
    this.setMindate(splitDate);
    this.newScheduleForm.get("time").setValue(splitTime);
  }

  setMindate(startDate?) {
    const custFormat = new CustomDateParserFormatter();
    const date = startDate || new Date();
    this.fromParent.minDate = custFormat.parse(
      this.datePipe.transform(date, "yyyy-MM-dd")
    );
  }

  getCurrentUTCDate() {
    const todayDate = new Date();
    const currentUTCDate =
      todayDate.getUTCFullYear() +
      "-" +
      ("0" + (todayDate.getUTCMonth() + 1)).slice(-2) +
      "-" +
      todayDate.getUTCDate();
    return currentUTCDate;
  }

  getCurrentUTCTime() {
    const todayDate = new Date();
    const currentUTCTime =
      ("0" + todayDate.getUTCHours()).slice(-2) +
      ":" +
      ("0" + todayDate.getUTCMinutes()).slice(-2) +
      ":" +
      ("0" + todayDate.getUTCSeconds()).slice(-2);
    return currentUTCTime;
  }

  showCronList(): void {
    const modalRef = this.modalService.open(CronExpressionModalComponent, {
      ariaLabelledBy: "modal-basic-title",
      windowClass: "confirm-modal",
      centered: true,
      size: "lg",
      scrollable: true,
    });
    modalRef.componentInstance.keyBoardEvent = 'CRONLIST';
  }
}